export default __webpack_public_path__ + "static/media/information--caravan-trailer-parking--g1.71f0f60c.png";